import { IconPropsType } from '..';

export const ArrowUpDownIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.4">
      <path
        d="M4.00274 1.8L5.63351 3.2L6.40001 2.6307L4.38324 0.93379C4.17123 0.755408 3.82877 0.755408 3.61676 0.93379L1.60001 2.6307L2.36648 3.2L3.99729 1.8H4.00274Z"
        fill="white"
      />
      <path
        d="M2.3665 4.8L3.99727 6.2H4.00272L5.63353 4.8L6.40001 5.3693L4.38325 7.06622C4.17124 7.2446 3.82879 7.2446 3.61677 7.06622L1.60001 5.3693L2.3665 4.8Z"
        fill="white"
      />
    </g>
  </svg>
);
